// extracted by mini-css-extract-plugin
export var content = "_m3-1";
export var fullScreen = "_m3-0";